import React from "react";
import { Alert, Box } from "@mui/material";
import { spacing } from "../../styles/theme";
import SpecsPositionEditorSidebar from "./SpecsPositionEditorSidebar";
import SpecsPositionEditorMainContent from "./SpecsPositionEditorMainContent";
import SpecsPositionGroupEditor from "./SpecsPositionGroupEditor";
import {
  useSpecsModelContextValue,
  useSpecsModelSelector,
} from "./SpecsModelContext";
import { useSpecsEditorContextValue } from "./useSpecsEditor";

function SpecsPositionEditorSelectionSync() {
  const {
    editor: {
      identity: { productVersion },
      session,
      selectPositions,
    },
    selectedPositionId,
  } = useSpecsEditorContextValue();
  const positionIds = useSpecsModelSelector((model) =>
    (model.getVersion(productVersion)?.getPositions() ?? []).map(
      (position: any) => position.id
    )
  );

  React.useEffect(() => {
    const positionNav = session.nav.kind === "positions" ? session.nav : null;

    if (!positionIds.length) {
      if (positionNav?.positionId !== undefined) {
        selectPositions(undefined);
      }
      return;
    }

    const hasSelectedPosition =
      !!selectedPositionId && positionIds.includes(selectedPositionId);
    if (hasSelectedPosition) {
      return;
    }

    const navPositionId =
      positionNav?.positionId && positionIds.includes(positionNav.positionId)
        ? positionNav.positionId
        : null;
    const nextPositionId = navPositionId ?? positionIds[0];

    if (positionNav?.positionId !== nextPositionId) {
      selectPositions(nextPositionId);
    }
  }, [positionIds, selectPositions, selectedPositionId, session.nav]);

  return null;
}

export default function SpecsPositionEditorPage() {
  const { specsModel } = useSpecsModelContextValue();

  if (!specsModel) {
    return <Alert severity="info">Loading specs model for positions.</Alert>;
  }

  return (
    <>
      <SpecsPositionEditorSelectionSync />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "280px 1fr" },
          gap: spacing.groupingDesktop,
          mb: spacing.groupingDesktop,
        }}
      >
        <SpecsPositionEditorSidebar />
        <SpecsPositionEditorMainContent />
      </Box>
      <SpecsPositionGroupEditor />
    </>
  );
}
